import { render } from "./AgencyDetail.vue?vue&type=template&id=60b1336e"
import script from "./AgencyDetail.vue?vue&type=script&lang=js"
export * from "./AgencyDetail.vue?vue&type=script&lang=js"

import "./AgencyDetail.vue?vue&type=style&index=0&id=60b1336e&lang=css"

import exportComponent from "C:\\Users\\khurr\\OneDrive\\desktop\\development\\refinedhealthpros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__